import React from 'react';
import { FaChartBar, FaUsers, FaDollarSign, FaChartLine } from 'react-icons/fa';

const BusinessMetricsGrid = ({ marcasStats, dashboardMetrics }) => {
    if (!marcasStats || marcasStats.length === 0) {
        return (
            <div className="grid grid-cols-2 gap-3">
                <div className="bg-gradient-to-br from-white to-gray-50 rounded-lg p-3 border border-gray-200 text-center">
                    <FaUsers className="text-2xl text-gray-300 mx-auto mb-2" />
                    <p className="text-gray-500 text-xs">No hay datos disponibles</p>
                </div>
            </div>
        );
    }

    // Usar las métricas calculadas correctamente desde el hook
    const {
        nuevosClientes,
        ticketPromedio,
        ventasTotales,
        crecimiento
    } = dashboardMetrics || {
        nuevosClientes: 0,
        ticketPromedio: 0,
        ventasTotales: 0,
        crecimiento: {
            nuevosClientes: 0,
            ticketPromedio: 0,
            ventasTotales: 0
        }
    };

    const metrics = [
        {
            title: 'Nuevos Clientes',
            value: nuevosClientes.toLocaleString(),
            icon: FaUsers,
            color: 'blue',
            change: crecimiento.nuevosClientes > 0 ? `+${crecimiento.nuevosClientes.toFixed(1)}%` :
                crecimiento.nuevosClientes < 0 ? `${crecimiento.nuevosClientes.toFixed(1)}%` : '0%',
            changeType: crecimiento.nuevosClientes > 0 ? 'positive' :
                crecimiento.nuevosClientes < 0 ? 'negative' : 'neutral'
        },
        {
            title: 'Ticket Promedio',
            value: `€${ticketPromedio.toFixed(2)}`,
            icon: FaChartBar,
            color: 'purple',
            change: crecimiento.ticketPromedio > 0 ? `+${crecimiento.ticketPromedio.toFixed(1)}%` :
                crecimiento.ticketPromedio < 0 ? `${crecimiento.ticketPromedio.toFixed(1)}%` : '0%',
            changeType: crecimiento.ticketPromedio > 0 ? 'positive' :
                crecimiento.ticketPromedio < 0 ? 'negative' : 'neutral'
        },
        {
            title: 'Ventas Totales',
            value: `€${ventasTotales.toLocaleString()}`,
            icon: FaDollarSign,
            color: 'green',
            change: crecimiento.ventasTotales > 0 ? `+${crecimiento.ventasTotales.toFixed(1)}%` :
                crecimiento.ventasTotales < 0 ? `${crecimiento.ventasTotales.toFixed(1)}%` : '0%',
            changeType: crecimiento.ventasTotales > 0 ? 'positive' :
                crecimiento.ventasTotales < 0 ? 'negative' : 'neutral'
        },
        {
            title: '% Crecimiento vs. mes anterior',
            value: `${((crecimiento.ventasTotales + crecimiento.ticketPromedio + crecimiento.nuevosClientes) / 3).toFixed(1)}%`,
            icon: FaChartLine,
            color: 'orange',
            change: 'Promedio general',
            changeType: 'neutral'
        }
    ];

    const getColorClasses = (color) => {
        switch (color) {
            case 'blue':
                return 'bg-blue-500 text-blue-600';
            case 'green':
                return 'bg-green-500 text-green-600';
            case 'purple':
                return 'bg-purple-500 text-purple-600';
            case 'orange':
                return 'bg-orange-500 text-orange-600';
            default:
                return 'bg-blue-500 text-blue-600';
        }
    };

    const getChangeColor = (changeType) => {
        switch (changeType) {
            case 'positive':
                return 'text-green-600';
            case 'negative':
                return 'text-red-600';
            default:
                return 'text-gray-500';
        }
    };

    return (
        <div className="grid grid-cols-2 gap-3">
            {metrics.map((metric, index) => {
                const IconComponent = metric.icon;
                return (
                    <div key={index} className="bg-gradient-to-br from-white to-gray-50 rounded-lg p-3 border border-gray-200 hover:shadow-md transition-shadow">
                        <div className="flex items-center justify-between mb-2">
                            <div className={`p-2 rounded-lg ${getColorClasses(metric.color).split(' ')[0]}`}>
                                <IconComponent className={`text-lg ${getColorClasses(metric.color).split(' ')[1]}`} />
                            </div>
                            <span className={`text-xs font-semibold ${getChangeColor(metric.changeType)}`}>
                                {metric.change}
                            </span>
                        </div>
                        <div>
                            <h3 className="text-lg font-bold text-gray-800">
                                {metric.value}
                            </h3>
                            <p className="text-xs text-gray-600 mt-1">
                                {metric.title}
                            </p>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default BusinessMetricsGrid; 